import { parsePhoneNumber } from 'awesome-phonenumber'

export default defineNuxtPlugin(() => {
  return {
    provide: {
      parsePhoneNumber: (
        phonenumber: string,
        optionsObject: { regionCode: string }
      ) => parsePhoneNumber(phonenumber, optionsObject),
    },
  }
})
